import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  initializeFirestore,
  memoryLocalCache,
  persistentLocalCache,
  persistentMultipleTabManager,
  serverTimestamp
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics, isSupported as analyticsSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Auth, Firestore, Storage
export const auth = getAuth(app);
export const storage = getStorage(app);
export const serverTime = serverTimestamp;

// ✅ Initialize Firestore with safe caching
let db;

// In production: persistent multi-tab cache
if (process.env.NODE_ENV === "production") {
  try {
    db = initializeFirestore(app, {
      localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
    });
    console.log("✅ Firestore initialized with multi-tab persistence.");
  } catch (err) {
    console.warn("⚠️ IndexedDB not supported. Using in-memory cache instead.", err);
    db = initializeFirestore(app, { localCache: memoryLocalCache() });
  }
} else {
  // In development: use memory cache instead of persistent cache to prevent assertion failures
  db = initializeFirestore(app, { localCache: memoryLocalCache() });
  console.log("🧠 Firestore initialized with memory cache for development.");
}

export { db };

// ✅ Initialize Analytics only if supported
analyticsSupported().then((supported) => {
  if (supported) {
    getAnalytics(app);
    console.log("📊 Analytics initialized.");
  } else {
    console.warn("Analytics not supported in this environment.");
  }
});
